import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConLinks: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConLinkMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConLinksRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConLinks", null);
            } else {
                dispatch("receivingWebConLinks"); // สถานะ กำลังบันทึก


                // axios.get('/web_con_links').then(res => {
                //
                //     dispatch("receiveWebConLinks", res.data);
                // })
                const formData = new FormData();
                formData.append('links_group_tag', payload.links_group_tag);
                formData.append('links_type_tag', payload.links_type_tag);

                axios.get('/web_con_links', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConLinks", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConLinks", null);
                    });

            }
        },
        loadWebConLinkRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConLink", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConLink");
                axios.get('/web_con_links/' + id).then(res => {
                    dispatch("receiveWebConLink", res.data);
                })
            }
        },
        updateWebConLinkRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConLink");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('file_en', payload.avatarFileEn);
            formData.append('links_id', payload.links_id);
            formData.append('links_group_tag', payload.links_group_tag);
            formData.append('links_type_tag', payload.links_type_tag);
            formData.append('links_h_icon', payload.links_h_icon);
            formData.append('links_h_color', payload.links_h_color);
            formData.append('links_h_image_th', payload.links_h_image_th);
            formData.append('links_h_image_en', payload.links_h_image_en);
            formData.append('links_title_th', payload.links_title_th);
            formData.append('links_title_en', payload.links_title_en);
            formData.append('links_desc_th', payload.links_desc_th);
            formData.append('links_desc_en', payload.links_desc_en);
            formData.append('links_content_th', payload.links_content_th);
            formData.append('links_content_en', payload.links_content_en);
            formData.append('status_cover', payload.status_cover);
            formData.append('links_url', payload.links_url);
            formData.append('links_url_manual', payload.links_url_manual);
            formData.append('order_seq', payload.order_seq);
            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);

            axios.post('/update_con_links', formData).then(res => {
                dispatch("updateWebConLink", res.data);
            })

        },
        createWebConLinkRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConLink");

            const formData = new FormData();

            formData.append('file', payload.avatarFile);
            formData.append('file_en', payload.avatarFileEn);
            formData.append('links_id', payload.links_id);
            formData.append('links_group_tag', payload.links_group_tag);
            formData.append('links_type_tag', payload.links_type_tag);
            formData.append('links_h_icon', payload.links_h_icon);
            formData.append('links_h_color', payload.links_h_color);
            formData.append('links_h_image_th', payload.links_h_image_th);
            formData.append('links_h_image_en', payload.links_h_image_en);
            formData.append('links_title_th', payload.links_title_th);
            formData.append('links_title_en', payload.links_title_en);
            formData.append('links_desc_th', payload.links_desc_th);
            formData.append('links_desc_en', payload.links_desc_en);
            formData.append('links_content_th', payload.links_content_th);
            formData.append('links_content_en', payload.links_content_en);
            formData.append('status_cover', payload.status_cover);
            formData.append('links_url', payload.links_url);
            formData.append('links_url_manual', payload.links_url_manual);
            formData.append('order_seq', payload.order_seq);
            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);


            axios.post('/web_con_links', formData).then(res => {
                dispatch("receiveWebConLink", res.data);

            })


        },
        deleteWebConLinkRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConLink", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConLink", payload);

            axios.post('/delete_con_links', payload).then(res => {
                dispatch("deleteWebConLink", {links_id: payload.links_id, res: res});
            })


        },
        receiveWebConLinks({commit}, payload) {
            commit("RECEIVED_CONLINKS", payload)
        },
        receivingWebConLinks({commit}) {
            commit("RECEIVING_CONLINKS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConLink({commit}, payload) {
            commit("RECEIVED_CONLINK", payload)
        },
        receivingWebConLink({commit}) {
            commit("RECEIVING_CONLINKS") //call matutions --> state.isReceiving = true;
        },
        updateWebConLink({commit}, payload) {
            commit("UPDATED_CONLINK", payload)
        },
        updatingWebConLink({commit}) {
            commit("UPDATING_CONLINK") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConLink({commit}, payload) {
            commit("DELETED_CONLINK", payload)
        },
        deletingWebConLink({commit}, payload) {
            commit("DELETING_CONLINK", payload)
        },
        afterDeleteWebConLink({commit}, payload) {
            commit("AFFTER_DELETED_CONLINK", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONLINKS(state, payload) {
            state.webConLinks = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONLINKS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONLINK(state, payload) {


            if (payload.links_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConLinkMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConLinkMessage: (state.webConLinkMessage == webConLinkMessage ? webConLinkMessage + ' ' : webConLinkMessage),

                });
            } else {
                let webConLinkMessage = 'บันทึกสำเร็จ! รายการ ' + payload.links_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConLinks: [...state.webConLinks, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConLinkMessage: (state.webConLinkMessage == webConLinkMessage ? webConLinkMessage + ' ' : webConLinkMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_CONLINK(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_CONLINK(state, payload) {
            let index = state.webConLinks.findIndex(p => p.links_id === payload.links_id);
            let webConLinkMessage = 'บันทึกสำเร็จ! รายการ ' + payload.links_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConLinks: state.webConLinks.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConLinkMessage: (state.webConLinkMessage == webConLinkMessage ? webConLinkMessage + ' ' : webConLinkMessage),
            })
        },
        UPDATING_CONLINK(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONLINK(state, payload) {


            if (payload.links_id == undefined || payload.res.data.message == 'Relation') {
                let webConLinkMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.links_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConLinkMessage: (state.webConLinkMessage == webConLinkMessage ? webConLinkMessage + ' ' : webConLinkMessage),

                });
            } else {
                let indexToDelete = state.webConLinks.findIndex(p => p.links_id === payload.links_id);
                let webConLinks = [...state.webConLinks];
                webConLinks.splice(indexToDelete, 1);
                let webConLinkMessage = 'บันทึกสำเร็จ! รายการ ' + payload.links_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConLinks: [...webConLinks],
                    isDeleting: false,
                    idToDelete: null,
                    webConLinkMessage: (state.webConLinkMessage == webConLinkMessage ? webConLinkMessage + ' ' : webConLinkMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONLINK(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.links_id;
        },
        AFFTER_DELETED_CONLINK(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
